import * as React from 'react';
import { TVerifyEmail } from './VerifyEmail.types';
import './VerifyEmail.styles.scss';
import { useUrlParams } from 'hooks/useUpdateUrlParams';
import { useNavigate } from 'react-router';
import { useAppDispatch } from 'store/store';
import { APP_ROUTES } from 'constants/routes';
import { verifyEmailAsyncThunk } from 'store/users/users.action';
import { useModals } from 'hooks/useModals';
import { MODALS } from 'store/contexts/ModalContext/modals';
import { Loader } from 'components';

export const VerifyEmail: TVerifyEmail = () => {
  const { getAllParams } = useUrlParams();
  const { openModal } = useModals();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const token = getAllParams().token as string;

  React.useEffect(() => {
    if (token) {
      setTimeout(
        () =>
          dispatch(
            verifyEmailAsyncThunk({
              token: token,
              onSuccess: () => {
                openModal(MODALS.LOGIN);
              },
            })
          ).finally(() => navigate(APP_ROUTES.HOME)),
        1000
      );
    } else {
      navigate(APP_ROUTES.HOME);
    }
  }, [token, dispatch]);

  return (
    <div className="verify-email">
      <div className="verify-email__container">
        <Loader />
      </div>
    </div>
  );
};
